import router from "./router";
import Cookies from 'js-cookie'
import tracker from './analytics/tracker.js'

router.beforeEach(async (to, from, next) => {
  const paths = ['/','/chanpin/hujiaozhongxin','/chanpin/duanxinyingxiao','/chanpin/guanggaozhushou','/shutong','/tianqi','/zhaoshangqudao','/jiage','/guanyuwomen','/datallApiquanbu','/datalljibenxinxi', '/apiList']

  if (from.path !== '/' && window.performance && window.performance.navigation.type === 2) {
    // 执行您的逻辑，例如不重定向
    // 直接调用 next() 继续路由跳转流程
    next();
  } else {
    // 如果不是刷新，则检查 cookies 和路由路径
    // 官网页面登录后台管理页面 路由不跳转 未找到原因 暂时在路由守卫处拦截重定向
    if (Cookies.get("userId") && paths.includes(to.path)) {
      next({path: "/index"});
    } else {
      next(); // 允许路由继续
    }
  }
});

// 埋点：SPA 路由变化自动上报 PV（新增，原项目无 afterEach）
router.afterEach((to) => {
  tracker.pageView({ path: to.path, query: to.query })
});



// WEBPACK FOOTER //
// ./src/permission.js